import { UserInfo, Srp, ReadStatus } from '@/types'
import { isProduction } from '@/utils/env'
import { postLogout } from '@/api/user'

/**
 * コースIDからコース名を取得
 *
 * @param number courseId コースID
 * @return string コース名
 */
export const getCourseName = (courseId: number): string => {
  if (courseId === 1) {
    return 'フリープラン'
  } else if (courseId === 2) {
    return 'シルバープラン'
  } else if (courseId === 3) {
    return 'ゴールドプラン'
  }
  return ''
}

/**
 * SRPの状態を取得
 */
export const getSrpStatus = (user?: UserInfo): Srp => {
  if (!user || !user.use_srp) return Srp.OFF_SRP

  if (user.biz_group_id === 0 || user.biz_group_use_srp === Srp.OPEN_SRP) {
    // 個人SRP ONユーザー or 法人OPENでSRP ONユーザー
    return Srp.OPEN_SRP
  } else if (user.biz_group_use_srp === Srp.CLOSE_SRP) {
    // 法人CLOSEでSRP ONユーザー
    return Srp.CLOSE_SRP
  }
  return Srp.OFF_SRP
}

/**
 * 読書ステータスを返す
 *
 * @param number percent 読了率
 * @return ReadStatus
 */
export const getReadStatus = (percent: number): ReadStatus => {
  if (percent === 100) return ReadStatus.Finish
  if (0 < percent && percent < 100) return ReadStatus.Reading
  return ReadStatus.NotRead
}

/**
 * ユーザーがフライヤー編集部か判定
 *
 * @param true: フライヤー編集部、false: フライヤー編集部ではない
 */
export const isFlierEditor = (userId: number): boolean => {
  return userId === 966715
}

/**
 * ユーザーが法人ユーザーか判定
 *
 * @param true: 法人ユーザー、false: 法人ユーザーではない
 */
export const isBizUser = (bizGroupId: number): boolean => {
  return bizGroupId > 0
}

/**
 * 施設型ユーザーか判定
 * IP施設型、BSSID施設型、URL型いずれかである場合、施設型であるとみなす
 *
 * @param true: 施設型、false: 施設型ではない
 */
export const isFacility = (email?: string): boolean => {
  if (!email) return false
  return (
    email.includes('net.flierinc') ||
    email.includes('bssid.flierinc') ||
    email.includes('limited_url.flierinc')
  )
}

/**
 * URL配布型ユーザーか判定
 *
 * @param true: URL配布型ユーザー、false: URL配布型ユーザーではない
 */
export const isLimitedUrlUser = (email?: string): boolean => {
  if (!email) return false
  return email.includes('limited_url.flierinc')
}

/**
 * みずほユーザーか判定
 * biz_group_id == 255の場合、みずほユーザであるとみなす
 *
 * @param true: みずほユーザー、false: みずほユーザーではない
 */
export const isMhfg = (userInfo: UserInfo): boolean => {
  if (!isProduction()) {
    return (
      userInfo?.result &&
      userInfo?.biz_group_id &&
      userInfo?.biz_group_id == 255
    )
  }
  return false
}

export const logout = async (): Promise<void> => {
  try {
    localStorage.removeItem('flier_id')
    await postLogout()
  } catch (e) {
    console.error(e)
  }
}

/**
 * セブン&アイユーザーか判定
 * biz_group_id == 212の場合、セブン&アイユーザであるとみなす
 *
 * @param true: セブン&アイユーザー、false: セブン&アイユーザーではない
 */
export const isSevenAndI = (userInfo: UserInfo): boolean => {
  return (
    userInfo?.result && userInfo?.biz_group_id && userInfo?.biz_group_id == 212
  )
}
